import { createApiInstance } from "./api";

// As rotas de /analytics da entrega 6 do RPAA-286. O contrato esta no plano da entrega 6, no
// backend (docs/superpowers/plans/2026-10-14-rpaa-286-entrega-6-api-e-pagina.md, "Contrato").
// period e {from, to, tz}: dias de calendario e o fuso do browser (utils/analyticsPeriod.js).
const analyticsApiInstance = createApiInstance("/analytics");

const periodParams = (chatId, period) => ({ chat_id: chatId, from: period.from, to: period.to, tz: period.tz });

// Os tres CSV como Blob, pela instancia (Bearer, X-Tenant-ID e o refresh), como os anexos do
// conversationsApi. Num erro o corpo tambem e um Blob, com o JSON do `detail` la dentro: quem apanhar tem
// de ler o texto para o mostrar, como faz o AnalyticsFilters. Os contratos das duas rotas da entrega 5 do
// redesign estao no plano dela (2026-10-15-rpaa-286-exportar-analytics.md, "Contrato").
const csv = async (path, chatId, period) => {
  const response = await analyticsApiInstance.get(path, { params: periodParams(chatId, period), responseType: "blob" });
  return response.data;
};

export const analyticsApi = {
  summary: async (chatId, period) => {
    const response = await analyticsApiInstance.get("/summary", { params: periodParams(chatId, period) });
    return response.data;
  },

  firstQuestions: async (chatId, period, { offset = 0, limit = 20 } = {}) => {
    const response = await analyticsApiInstance.get("/first-questions", {
      params: { ...periodParams(chatId, period), offset, limit },
    });
    return response.data;
  },

  assistant: async (chatId, period) => {
    const response = await analyticsApiInstance.get("/assistant", { params: periodParams(chatId, period) });
    return response.data;
  },

  signedInCustomers: async (chatId, period) => {
    const response = await analyticsApiInstance.get("/signed-in-customers", { params: periodParams(chatId, period) });
    return response.data;
  },

  pages: async (chatId, period) => {
    const response = await analyticsApiInstance.get("/pages", { params: periodParams(chatId, period) });
    return response.data;
  },

  csatByOperator: async (chatId, period) => {
    const response = await analyticsApiInstance.get("/csat-by-operator", { params: periodParams(chatId, period) });
    return response.data;
  },

  conversationsCsv: (chatId, period) => csv("/conversations.csv", chatId, period),
  dailyCsv: (chatId, period) => csv("/daily.csv", chatId, period),
  firstQuestionsCsv: (chatId, period) => csv("/first-questions.csv", chatId, period),
};
